import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  private readonly url = 'mag-erp-admin/products';

  constructor(private http: HttpClient) {
  }

  getList(lazyLoadEvent: string): Observable<any> {
    return this.http.get(`${this.url}?lazyLoadEvent=${lazyLoadEvent}`);
  }

  get(id: string): Observable<any> {
    return this.http.get(`${this.url}/${id}`);
  }

  create(item: any): Observable<any> {
    return this.http.post(`${this.url}`, item);
  }

  update(id: string, item: any): Observable<any> {
    return this.http.put(`${this.url}/${id}`, item);
  }

  delete(id: string): Observable<any> {
    return this.http.delete(`${this.url}/${id}`);
  }

  status(id: string, statusId: string): Observable<any> {
    return this.http.patch(`${this.url}/${id}/statusId/${statusId}`, null);
  }

  search(params: any): Observable<any> {
    return this.http.get(`${this.url}/search`, {params});
  }

  getAssets(productId: string): Observable<any> {
    return this.http.get(`${this.url}/${productId}/assets`);
  }

  getPseudoId(idValue: string): Observable<any> {
    return this.http.get(`${this.url}/pseudoId?idValue=${idValue}`);
  }

  discontinuation(id: string, body: any): Observable<any> {
    return this.http.put(`${this.url}/${id}/sales-discontinuation`, body);
  }

  continuation(id: string, body: any): Observable<any> {
    return this.http.put(`${this.url}/${id}/sales-continuation`, body);
  }

  getSalesState(id: string): Observable<any> {
    return this.http.get(`${this.url}/${id}/sales-state`);
  }

  getSellRate(id: string): Observable<any> {
    return this.http.get(`${this.url}/${id}/sell-rate`);
  }

  getTikiFbt(id: string): Observable<any> {
    return this.http.get(`${this.url}/${id}/assets/tiki-fbt-atp`);
  }

  findProductByOtherIdentification(sku: string): Observable<any> {
    return this.http.get(`mag-tiki-tools/${sku}/products`);
  }

}
